/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb

import 'bootstrap';
import Rails from 'rails-ujs';
import 'store_front/startup';
import 'store_front'
import * as Routes from 'routes'; 

window.Rails = Rails; 
Rails.start();
window.$ = jQuery;
window.Routes = Routes; 



// document.addEventListener('turbolinks:load', function(){
//     (function(d, s, id) {
//   var js, fjs = d.getElementsByTagName(s)[0];
//   if (d.getElementById(id)) return;
//   js = d.createElement(s); js.id = id;
  
//   js.src = 'https://connect.facebook.net/en_US/sdk/xfbml.customerchat.js';
//   fjs.parentNode.insertBefore(js, fjs);
//         }(document, 'script', 'facebook-jssdk'));

//    load_facebook_chat()
//  })
  

// function load_facebook_chat(was_failure){
//   if (was_failure) {

//   }
//    if (typeof FB !== "undefined" && FB !== null) { // Instance of FacebookSDK
//     try {
//       FB.init({
//         xfbml: false, 
//         version: 'v12.0'
//       })
//     // FB.XFBML.parse(null, function(){
//     //   // setTimeout(function(){
//     //   // let nodes = document.querySelectorAll('#fb-root iframe'); 
//     //   // for (let i = 0; i < nodes.length; i++) {
//     //   //   nodes[i].style.maxHeight  = '60px'; 
//     //   // }
//     //   // }, 200)

//     // })

//     }
//     catch(e) {
//       setTimeout(function() {load_facebook_chat(true) }, 50); 

//     }
//    }
//   else {
//     setTimeout(load_facebook_chat, 50); 
//   }
// }






// WEBPACK FOOTER //
// ./app/javascript/packs/store_front.js